import { useEffect, useMemo, useState } from "react"
import breakpoints from "@/constants/breakpoints"
import useWindowSize from "@/hooks/useWindowSize"

const useIsMobile = () => {
  const { width } = useWindowSize()
  const [isCaraxMobile, setIsCaraxMobile] = useState(false)

  const isBrowserMobile = useMemo(() => width < breakpoints.sm, [width])

  useEffect(() => {
    //@ts-ignore
    if (!window.demon?.platform) return

    //@ts-ignore
    const isMobile = ["ios", "android"].includes(window.demon.platform.toLowerCase())
    setIsCaraxMobile(isMobile)
  }, [])

  return isBrowserMobile || isCaraxMobile
}

export default useIsMobile
